<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button
            link="/planned-maintenance/miscellaneous-items"
          ></back-button>
          Update Miscellaneous Item
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-4 col-sm-6 col-md-4 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Planned Maintenance</li>
          <li class="breadcrumb-item">
            <router-link :to="`/planned-maintenance/miscellaneous-items`"
              >Miscellaneous Items</router-link
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">Update</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-10 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Vessel</label>
              <div class="col-sm-10">
                <my-select
                  style="margin: 9px !important"
                  disableFormControl="true"
                  :selection.sync="form.vessel_id"
                  :suggestions="vessels"
                  placeholder="Select vessel"
                ></my-select>
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Item</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  v-model="form.item"
                  class="form-control"
                  placeholder="Item"
                />
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Partner Number</label>
              <div class="col-sm-10">
                <input
                  type="number"
                  v-model="form.partner_no"
                  class="form-control"
                  placeholder="Partner Number"
                />
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Draw Number</label>
              <div class="col-sm-10">
                <input
                  type="number"
                  v-model="form.drawn_no"
                  class="form-control"
                  placeholder="Draw Number"
                />
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Make</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  v-model="form.make"
                  class="form-control"
                  placeholder="Make"
                />
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Model Number</label>
              <div class="col-sm-10">
                <input
                  type="number"
                  v-model="form.model_no"
                  class="form-control"
                  placeholder="Model Number"
                />
              </div>
            </div>
            <div class="form mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="update"
                text="Update"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "ConsumptionTypeUpdate",
  data() {
    return {
      form: {
        vessel_id: "",
      },
      vessels: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("miscellaneous_items/masters");
      masters = masters.data;
      masters.vessels.forEach((vessel) => {
        this.vessels.push({
          id: vessel.id,
          name: vessel.name,
        });
      });
    },
    async getData() {
      this.isLoading = true;
      let form = await axios.get(
        `/miscellaneous_items/${this.$route.params.miscellaneous_item_Id}`
      );
      this.form = form.data.data;
      this.isLoading = false;
    },
    async update() {
      try {
        this.isLoading = true;
        await axios.patch(
          `/miscellaneous_items/${this.$route.params.miscellaneous_item_Id}`,
          this.form
        );
        this.isLoading = false;
        this.$router.push("/planned-maintenance/miscellaneous-items");
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>
